import i18n from 'i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { defaultLang, isDevelopment, Langs } from '@/constants';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLang,
    load: 'currentOnly',
    whitelist: Langs,
    debug: isDevelopment,
    cleanCode: true,
    defaultNS: 'common',
    ns: 'common',

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      allowMultiLoading: false,
      crossDomain: false
    },
    detection: {
      order: ['path']
    }
  });

export default i18n;
